// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[data-v-763b8620] {\n  font-family: var(--interfaceFontTypeface, inherit);\n  color: var(--interfaceFontColor, inherit);\n  font-weight: var(--interfaceFontWeight, inherit);\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
